import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { BoardDTO } from '../../../api/board-api';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import {
    FormikCellToggle,
    FormikDateInput,
    FormikNumberInput,
    FormikTextField,
} from '../../../components/formik';
import { yup } from '../../../components/basic/yup';
import SvgSave from '../../../assets/icons/Save';
import SvgDelete from '../../../assets/icons/Delete';
import SvgClose from '../../../assets/icons/Close';

interface SaveBoardModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedBoard?: BoardDTO;
    onHide: () => void;
    onSave: (values: BoardDTO) => void;
    onDelete?: (board: BoardDTO) => void;
}

export function SaveBoardModal({
    show,
    allowEdit,
    selectedBoard,
    onHide,
    onSave,
    onDelete,
}: SaveBoardModalProps) {
    const BoardSchema = yup.object().shape({
        title: yup.string().required(' '),
        height: yup.number().required(' '),
        width: yup.number().required(' '),
        latitude: yup.number(),
        longitude: yup.number(),
        address: yup.string(),
    });

    const defaultValues: BoardDTO = {
        id: selectedBoard?.id,

        title: selectedBoard ? selectedBoard.title : '',
        height: selectedBoard ? selectedBoard.height : 0,
        width: selectedBoard ? selectedBoard.width : 0,
        latitude: selectedBoard ? selectedBoard.latitude : 0,
        longitude: selectedBoard ? selectedBoard.longitude : 0,
        address: selectedBoard ? selectedBoard.address : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={BoardSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedBoard ? 'edit-board' : 'new-board'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedBoard && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedBoard)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    disabled={!allowEdit}
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="title"
                                name="title"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="height"
                                name="height"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="width"
                                name="width"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="latitude"
                                name="latitude"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="longitude"
                                name="longitude"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="address"
                                name="address"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
